import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export const newOrderService = async (): Promise<ResponseAPI> => {
  const response = await api.get('novopedido')
  return response.data
}
